import { VGSpy } from "vgscrollto";

function enableVGSpy() {
	const navs = Array.from(document.querySelectorAll("[data-vgspy]"));

	if (navs.length) {
		const navLinks = navs.map((nav) => ({
			nav,
			links: nav.querySelectorAll("[data-target], a[href*='#']"),
		}));

		function applyOffsetUpByWidth() {
			let valueUp = "-80";
			let valueDown = "-80";

			if (window.innerWidth <= 667) {
				valueUp = "-30";
				valueDown = "-30";
			} else if (window.innerWidth <= 1200) {
				valueDown = "0";
			}

			navLinks.forEach(({ links }) => {
				links.forEach((link) => {
					link.dataset.offsetUp = valueUp;
					link.dataset.offsetDown = valueDown;
				});
			});
		}

		navs.forEach((nav) => new VGSpy(nav));
		applyOffsetUpByWidth();

		window.addEventListener("resize", applyOffsetUpByWidth, { passive: true });
	}
}

document.addEventListener("DOMContentLoaded", () => enableVGSpy);

typeof onTurboRender !== 'undefined' && onTurboRender(() => {
	window.requestAnimationFrame(enableVGSpy);
});
